export default {
  'SentimentChartTooltip.positive': 'Positive',
  'SentimentChartTooltip.negative': 'Negative',
  'SentimentChartTooltip.neutral': 'Neutral',
}
